import { Pipe, PipeTransform } from '@angular/core';
import { FormItem } from '../_models/formitem';


@Pipe({
    name: 'Categoryfilter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: FormItem[], id: any): any {
    if(!items)
      return [];

    if(id == 0)
      return items;

      return items.filter(it => {
        let tres = false;
        it.categories.forEach(function(value) {
          if(value.categoryId == id) {
            tres = true;
          }
        });
        return tres;

      });
   
  
  }


}
